// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_page__sMjkl {
  min-height: 100vh;
  padding: 1rem 1rem 2rem;
}

.styles_card__zuyVf {
  position: relative;
  max-width: 1500px;
  margin: 0.35rem auto 0;
  background: #ffffff;
  border-radius: 14px;
  padding: 1.1rem 1.35rem 0.6rem;
  box-shadow: 0 10px 24px rgba(3, 15, 36, 0.14);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.styles_infoGrid__Wlgze {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
  padding: 1.25rem;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e1e6ee;
}

.styles_infoItem__2YAD\\+ {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.9rem;
  color: #64748b;
}

.styles_infoItem__2YAD\\+ strong {
  color: #0f172a;
  font-size: 1rem;
  font-weight: 600;
}


.styles_totalsRow__9WHkM {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.styles_totalCard__CKMK8 {
  border-radius: 12px;
  padding: 1.25rem;
  color: #0f172a;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 1px solid transparent;
  align-items: center;
  text-align: center;
}

.styles_totalCard__CKMK8 span {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.styles_totalCard__CKMK8 strong {
  font-size: 1.5rem;
  color: #ffffff;
}

.styles_totalEcd__8PY1Z {
  background: #1e3a8a;
}

.styles_totalPis__8uwiy {
  background: #2563eb;
}

.styles_totalCofins__PnAWA {
  background: #dc2626;
}

.styles_filtrosContainer__1wd\\+4 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0;
  flex-wrap: wrap;
}

.styles_filtrosRight__2xTWz {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

/* Botão Exportar - mesmo padrão do Filtrar (azul escuro) */
.styles_botaoExportar__9S0jE {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.5rem;
  background-color: #18316e !important;
  background: #18316e !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 4px !important;
  font-size: 1rem !important;
  font-family: "Inter" !important;
  font-weight: normal !important;
  cursor: pointer !important;
  transition: transform 0.3s ease-in-out !important;
  box-shadow: none !important;
  text-transform: none !important;
  height: 40px !important;
  min-width: 120px !important;
  text-align: center !important;
}

.styles_botaoExportar__9S0jE:hover {
  transform: scale(1.1) !important;
}

.styles_botaoExportar__9S0jE:active {
  background-color: #1976d2 !important;
  background: #1976d2 !important;
}

.styles_botaoExportar__9S0jE:disabled {
  background-color: #6b6e76 !important;
  background: #6b6e76 !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

.styles_footer__vxgSI {
  margin-top: 0.15rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.35rem;
  padding: 0.3rem 0 0;
  border-top: 1px solid #e2e8f0;
}

.styles_footerLeft__a3jiK,
.styles_footerRight__1t9B9 {
  display: flex;
  align-items: center;
}

/* Botão Salvar verde */
.styles_botaoSalvar__Z8Nf1 {
  background-color: #16a34a !important;
  cursor: pointer;
  color: #fff !important;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none !important;
  gap: 5px;
  font-family: "Inter";
  font-size: 1rem;
  transition: transform 0.3s ease-in-out;
  border-radius: 4px;
  padding: 0.7rem;
  min-width: 8rem;
}

.styles_botaoSalvar__Z8Nf1:hover {
  transform: scale(1.1);
  background-color: #15803d !important;
}

.styles_botaoSalvar__Z8Nf1:active {
  background-color: #15803d !important;
}

.styles_botaoSalvar__Z8Nf1:disabled {
  background-color: #6b6e76 !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

@media (max-width: 768px) {
  .styles_page__sMjkl {
    padding: 2rem 1rem;
  }

  .styles_card__zuyVf {
    padding: 1.5rem;
  }

  .styles_footer__vxgSI {
    flex-direction: column;
    align-items: stretch;
  }

  .styles_footerLeft__a3jiK,
  .styles_footerRight__1t9B9 {
    justify-content: center;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/PreviaPISCOFINS/BaseLegal/styles.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,iDAAiD;EACjD,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,uBAAuB;EACzB;AACF","sourcesContent":[".page {\n  min-height: 100vh;\n  padding: 1rem 1rem 2rem;\n}\n\n.card {\n  position: relative;\n  max-width: 1500px;\n  margin: 0.35rem auto 0;\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 1.1rem 1.35rem 0.6rem;\n  box-shadow: 0 10px 24px rgba(3, 15, 36, 0.14);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.infoGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n  padding: 1.25rem;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #e1e6ee;\n}\n\n.infoItem {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.9rem;\n  color: #64748b;\n}\n\n.infoItem strong {\n  color: #0f172a;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n\n.totalsRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.totalCard {\n  border-radius: 12px;\n  padding: 1.25rem;\n  color: #0f172a;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  border: 1px solid transparent;\n  align-items: center;\n  text-align: center;\n}\n\n.totalCard span {\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.9);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.totalCard strong {\n  font-size: 1.5rem;\n  color: #ffffff;\n}\n\n.totalEcd {\n  background: #1e3a8a;\n}\n\n.totalPis {\n  background: #2563eb;\n}\n\n.totalCofins {\n  background: #dc2626;\n}\n\n.filtrosContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 0;\n  flex-wrap: wrap;\n}\n\n.filtrosRight {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n/* Botão Exportar - mesmo padrão do Filtrar (azul escuro) */\n.botaoExportar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1.5rem;\n  background-color: #18316e !important;\n  background: #18316e !important;\n  color: #ffffff !important;\n  border: none !important;\n  border-radius: 4px !important;\n  font-size: 1rem !important;\n  font-family: \"Inter\" !important;\n  font-weight: normal !important;\n  cursor: pointer !important;\n  transition: transform 0.3s ease-in-out !important;\n  box-shadow: none !important;\n  text-transform: none !important;\n  height: 40px !important;\n  min-width: 120px !important;\n  text-align: center !important;\n}\n\n.botaoExportar:hover {\n  transform: scale(1.1) !important;\n}\n\n.botaoExportar:active {\n  background-color: #1976d2 !important;\n  background: #1976d2 !important;\n}\n\n.botaoExportar:disabled {\n  background-color: #6b6e76 !important;\n  background: #6b6e76 !important;\n  cursor: not-allowed !important;\n  opacity: 0.6 !important;\n}\n\n.footer {\n  margin-top: 0.15rem;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.35rem;\n  padding: 0.3rem 0 0;\n  border-top: 1px solid #e2e8f0;\n}\n\n.footerLeft,\n.footerRight {\n  display: flex;\n  align-items: center;\n}\n\n/* Botão Salvar verde */\n.botaoSalvar {\n  background-color: #16a34a !important;\n  cursor: pointer;\n  color: #fff !important;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none !important;\n  gap: 5px;\n  font-family: \"Inter\";\n  font-size: 1rem;\n  transition: transform 0.3s ease-in-out;\n  border-radius: 4px;\n  padding: 0.7rem;\n  min-width: 8rem;\n}\n\n.botaoSalvar:hover {\n  transform: scale(1.1);\n  background-color: #15803d !important;\n}\n\n.botaoSalvar:active {\n  background-color: #15803d !important;\n}\n\n.botaoSalvar:disabled {\n  background-color: #6b6e76 !important;\n  cursor: not-allowed !important;\n  opacity: 0.6 !important;\n}\n\n@media (max-width: 768px) {\n  .page {\n    padding: 2rem 1rem;\n  }\n\n  .card {\n    padding: 1.5rem;\n  }\n\n  .footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .footerLeft,\n  .footerRight {\n    justify-content: center;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `styles_page__sMjkl`,
	"card": `styles_card__zuyVf`,
	"infoGrid": `styles_infoGrid__Wlgze`,
	"infoItem": `styles_infoItem__2YAD+`,
	"totalsRow": `styles_totalsRow__9WHkM`,
	"totalCard": `styles_totalCard__CKMK8`,
	"totalEcd": `styles_totalEcd__8PY1Z`,
	"totalPis": `styles_totalPis__8uwiy`,
	"totalCofins": `styles_totalCofins__PnAWA`,
	"filtrosContainer": `styles_filtrosContainer__1wd+4`,
	"filtrosRight": `styles_filtrosRight__2xTWz`,
	"botaoExportar": `styles_botaoExportar__9S0jE`,
	"footer": `styles_footer__vxgSI`,
	"footerLeft": `styles_footerLeft__a3jiK`,
	"footerRight": `styles_footerRight__1t9B9`,
	"botaoSalvar": `styles_botaoSalvar__Z8Nf1`
};
export default ___CSS_LOADER_EXPORT___;
